export default "__VITE_ASSET__DUoHB7bi__"